import { useEvent as r } from "../events.js";
import { useBindProp as g } from "../props.js";

function a(a, t) {
  g(a, {
    setter: "setDraggable"
  }, t.draggable), r(a, "dragstart", t.onDragStart), r(a, "dragging", t.onDragging), r(a, "dragend", t.onDragEnd);
}

export default a;